import { render } from "./ShowcaseView.vue?vue&type=template&id=b03ececc&scoped=true"
import script from "./ShowcaseView.vue?vue&type=script&lang=js"
export * from "./ShowcaseView.vue?vue&type=script&lang=js"

import "./ShowcaseView.vue?vue&type=style&index=0&id=b03ececc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b03ececc"]])

export default __exports__